import React, { PureComponent } from 'react';
import { Input, Radio, Row } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { RadioChangeEvent } from 'antd/lib/radio';

import Tags, { ITagProps } from 'src/components/DokTags';
import styles from './index.less';

const { Search } = Input;

const defaultProps = {
  simple: false,
  dataSource: [],
};
interface IProps {
  simple?: boolean;
  value: CheckboxValueType;
  dataSource: ITagProps[];
  onChange?: (v: CheckboxValueType) => void;
}

export default class Group extends PureComponent<IProps> {
  static defaultProps = defaultProps;
  readonly state = {
    search: '',
  };
  render() {
    const { dataSource, value = '', simple } = this.props;
    const { search } = this.state;

    const source = !search
      ? dataSource
      : dataSource.filter(
          (v) => (v.label || v.name).toLowerCase().indexOf(search.toLowerCase()) > -1
        );
    return (
      <>
        {!simple && (
          <Tags
            onChange={this.handleTagChange}
            dataSource={dataSource.filter((v) => [value].includes(v.value))}
          />
        )}
        {!simple && (
          <Search size="small" placeholder="搜索" allowClear onSearch={this.handleSearchChange} />
        )}
        <Radio.Group value={value} className={styles.group} onChange={this.handleRadioChange}>
          {source &&
            !!source.length &&
            source.map(({ label, value, name, ...props }) => (
              <Row key={value}>
                <Radio value={value} {...props}>
                  {label || name}
                </Radio>
              </Row>
            ))}
        </Radio.Group>
      </>
    );
  }
  handleSearchChange = (search: string) =>
    this.setState({ search: (search || '').replace(/(^\s*)|(\s*$)/g, '') });
  handleRadioChange = (e: RadioChangeEvent) => {
    const { onChange } = this.props;

    onChange && onChange(e.target.value);
  };
  handleTagChange = (val: Array<string | number>) => {
    const { onChange } = this.props;

    onChange && onChange(val[0]);
  };
}
